let domLoaded = false;
let igReady = false;

function handleExperiments() {
  if (!domLoaded || !igReady) return;

  // Test: V_BEL_PDP_03 | Perfekte-Passform-Garantie Framing
  const perfektePassform = window.igData?.user.getTestGroup("e4f037e7-95d6-42a2-a163-a40c365cd1f5");

  if (perfektePassform?.name === "Var A") {
    document.body.classList.add('c-perfektePassformVarA');
  }

  // Test: V_BEL_MIX_08 | Total Savings Banner in Cart Drawer
  const savingsBanner = window.igData?.user.getTestGroup("8c24c485-b611-4865-80e1-3b5ece796c89");

  if (savingsBanner?.name === "Var A") {
    document.body.classList.add('c-savingsBannerVarA');
  }

}

document.addEventListener("DOMContentLoaded", () => {
  domLoaded = true;
  handleExperiments();
});

window.addEventListener("ig:ready", () => {
  igReady = true;
  handleExperiments();
});
